import { User } from '../../../model/User';
import { api } from '../../../App';
import { parseUser } from '../../../parsers/user.parser';

export const getLoggedInUser = async (): Promise<User> => {
  /* Throws error when the user is not logged in */
  const response = await api.service.apiCookieGet();
  return parseUser(response.data);
};
